import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-property-type-confirmation',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    standalone: false
})
export class PropertyTypeConfirmationComponent extends ButtonStepComponent implements OnInit {
  title = "Does your home have a permanent foundation?";
  buttonList = 
  [
    { text: 'No', value: 'no', imageName: 'no-x', default: true},
    { text: 'Yes', value: 'yes', imageName: 'yes' },
  ];

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('propertyTypeConfirmation', this.control);
  }

  submit(button: any): void {
    if (button.value === "yes") { this.form.controls.propertyType.setValue('Manufactured'); }
    super.submit(button);
  }

}

